import { useHasUnread } from '@/features/notification'
import { ROUTER } from '@/shared/config'
import { useAuth } from '@/shared/context'
import { UiPopover } from '@/shared/ui'
import { BellOutlined as Bell, PaletteOutlined as Palette } from '@/shared/ui/icons'
import UiButton from '@/shared/ui/ui-button'
import UiButtonCircle from '@/shared/ui/ui-button-circle'
import UiSpace from '@/shared/ui/ui-space'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import LayoutSettingDrawer from '../../LayoutSettingDrawer'
import MenuUser from './MenuUser'
import NotificationList from './NotificationList'
import './index.scss'

const TopHeader = () => {
  const { isLogin } = useAuth()
  const navigate = useNavigate()
  const { userInfo } = useSelector((state: any) => state?.appGlobal)
  const [layoutSettingOpen, setLayoutSettingOpen] = useState(false)
  const { data: hasUnread = false } = useHasUnread({ enabled: !!isLogin })
  return (
    <div className="d-flex-end">
      <UiSpace size={8} align="center">
        {isLogin ? (
          <>
            <UiButtonCircle
              className="top-header-btn"
              bordered
              title="Thiết lập bố cục"
              icon={<Palette size={19} />}
              onClick={() => setLayoutSettingOpen(true)}
            />
            <UiPopover
              content={<NotificationList />}
              trigger="click"
              placement="bottomRight"
              overlayClassName="notification-popover"
            >
              <span className="notification-bell">
                <UiButtonCircle
                  className="top-header-btn"
                  bordered
                  title="Thông báo"
                  aria-label={hasUnread ? 'Có thông báo chưa đọc' : 'Thông báo'}
                  icon={<Bell size={19} />}
                />
                {hasUnread && <span className="notification-bell-dot" aria-hidden="true" />}
              </span>
            </UiPopover>
            <UiPopover content={<MenuUser />} trigger="click" placement="bottomRight">
              <div
                className="pointer account-infor-sumary-border"
                style={{ display: 'inline-flex', alignItems: 'center', padding: 0 }}
                title={userInfo?.fullName || userInfo?.username || 'Tài khoản'}
              >
                {/* ds-guard-ignore: vi phạm có sẵn trước khi chuyển từ components (C3) */}
                <div className="account-infor" style={{ padding: 0 }}>
                  <div className="header-avatar-rainbow" style={{ width: 40, height: 40 }}>
                    <img
                      src={userInfo?.avatar || '/user-holder.svg'}
                      alt="Avatar"
                      onError={(e) => {
                        const target = e.currentTarget
                        if (!target.src.endsWith('/user-holder.svg')) {
                          target.src = '/user-holder.svg'
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </UiPopover>
          </>
        ) : (
          <>
            <UiButton className="btn-login-header" onClick={() => navigate(ROUTER.LOGIN)}>
              Đăng nhập
            </UiButton>
          </>
        )}
      </UiSpace>
      <LayoutSettingDrawer open={layoutSettingOpen} onClose={() => setLayoutSettingOpen(false)} />
    </div>
  )
}

export default TopHeader
